export function convertToCSSPrefix(property) {
    return property
        .replace(/^Moz/, "-moz-")
        .replace(/^ms/, "-ms-")
        .replace(/^O/, "-o-")
        .replace(/^Webkit/, "-webkit-")
        .toLowerCase();
}
export default convertToCSSPrefix;

//# sourceMappingURL=convertToCSSPrefix.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-css-transition/lib/utils/convertToCSSPrefix.js
// module id = 220
// module chunks = 0